export default {
  token: '',
  user: {}
}
